import { useEffect, type ReactElement } from 'react'
import { useRouter } from 'next/router'
import useAuth from '@/hooks/useAuth'
import SEO from '@/components/seo'
import RegisterProTopView from '@/views/register-pro/top'

const RegisterProTopPage = (): ReactElement | null => {
  const { currentUser, isLoading: isAuthLoading } = useAuth()
  const router = useRouter()

  useEffect(() => {
    if (isAuthLoading) {
      return
    }

    if (currentUser?.isProfessional) {
      router.replace('/my')
    }
  }, [ currentUser, router, isAuthLoading ])

  return (
    <>
      <SEO title="クリエイターへ登録" url="register-pro" />
      <RegisterProTopView />
    </>
  )
}

export default RegisterProTopPage
